import { render } from "./PCBuscadorPaleConfeccionado.vue?vue&type=template&id=0eb09b7a&scoped=true"
import script from "./PCBuscadorPaleConfeccionado.vue?vue&type=script&lang=js"
export * from "./PCBuscadorPaleConfeccionado.vue?vue&type=script&lang=js"

import "./PCBuscadorPaleConfeccionado.vue?vue&type=style&index=0&id=0eb09b7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb09b7a"]])

export default __exports__